import React from 'react';
import Icon from '@material-ui/core/Icon';
import Card from 'components/Card/Card.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';
import withStyles from '@material-ui/core/styles/withStyles';
import chartsStyle from 'assets/jss/material-dashboard-pro-react/views/chartsStyle.jsx';

const TotalTicketsSold = ({ ticketCount, classes }) => {
  return (
    <Card>
      <CardHeader color="warning" icon>
        <CardIcon color="warning">
          <Icon>content_copy</Icon>
        </CardIcon>
        <p className={classes.cardCategory}>Tickets verkauft</p>
        <h3 className={classes.cardTitle}>{ticketCount}</h3>
      </CardHeader>
    </Card>
  );
};

export default withStyles(chartsStyle)(TotalTicketsSold);



// WEBPACK FOOTER //
// ./src/views/reports/components/TotalTicketsSold.jsx